import {post} from '@/api'
import {ConfirmEmailRequest, ConfirmEmailResponse} from '@/stores'
import {ENDPOINTS} from '@/constants/endpoints'

export const confirmEmail = (data: ConfirmEmailRequest) =>
    post<ConfirmEmailResponse>(ENDPOINTS.CONFIRM_EMAIL, data)
